import { render, staticRenderFns } from "./NeedHelpToFindLeakageQuestion.vue?vue&type=template&id=4f844c7e&scoped=true"
import script from "./NeedHelpToFindLeakageQuestion.vue?vue&type=script&lang=ts"
export * from "./NeedHelpToFindLeakageQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f844c7e",
  null
  
)

export default component.exports